import React , {useState}from "react";
import "../weather-temperature/weather-temperature.css";

export default function WeatherTemperature(props) {
    const [isMetric, setIsMetric] = useState(true);

    let fahrenheitTemperature = Math.round((props.celsius * 9) / 5 + 32);
    let celsiusTemperature = Math.round(props.celsius);

    const convertTemperatureToFahrenheit = (event) => {
        event.preventDefault();
        setIsMetric(false);
        
    };

    const convertTemperatureToCelsius = (event) => {
        event.preventDefault();
        setIsMetric(true);
    };

    return (
        <div>
            <strong className="temperature">{isMetric ? celsiusTemperature : fahrenheitTemperature}</strong>
            <a  
                onClick={convertTemperatureToCelsius} 
                id="celsius" 
                className={`temperature__link ${isMetric ? "active" : ""}`}
                href="#">
                ℃
            </a>
            <a  
                onClick={convertTemperatureToFahrenheit} 
                id="fahrenheit" 
                className={`temperature__link ${!isMetric ? "active" : ""}`}
                href="#">
                ℉
            </a>
        </div>
    );
}